<app-header></app-header>
<app-toolbar></app-toolbar>
<app-submenu [items]="subMenuItems" [backBgGray]="true"></app-submenu>

<main class="flex-1 bg-[#f6f6f6] pb-20 pt-10">

  <section
    class="bg-white border border-[#f0f0f0] rounded-[15px] mx-auto w-[95%] max-w-[1200px] p-2 shadow-[1px_1px_20px_0px_rgba(0,0,0,0.1)]">
    <div class="flex gap-2 flex-wrap justify-end mt-4 mb-5">
      <button type="button" (click)="exportExcel()"
        class="bg-green-600 justify-center items-center text-white text-xl font-bold rounded-xl h-10 w-60 sm:w-52 mb-2">
        Exportar excel
      </button>
    </div>
    <div class="flex justify-center gap-2 mt-4 pr-14 pb-3">
      <div *ngIf="utils.validatePermission('see_filter_ticket')">
        <p-dropdown [options]="dropDownFilterTicket"
          styleClass="bg-white px-[20px] py-[3px] rounded-[12px] border border-[#A3A3A3]" [style]="{ width: '300px' }"
          (onChange)="onSearchInput($event)" [(ngModel)]="selectedFilterTicket" optionLabel="name" [showClear]="true"
          placeholder="Seleccione una opción"></p-dropdown>
      </div>
      <div class="filter-calendar-container">
        <p-calendar styleClass="bg-white border border-[#A3A3A3] px-[20px] py-[10px] rounded-[12px]"
          (onSelect)="onSearchInput($event)" (onInput)="onSearchInput($event)" [(ngModel)]="dateFilter"
          placeholder="Filtro fecha"></p-calendar>
      </div>
      <div class="filter-office">
        <select class="bg-white border border-[#A3A3A3] px-[20px] py-[10px] rounded-[12px]" id=""
          (change)="onSearchInput($event)" [(ngModel)]="officeFilter">
          <option value="">Seleccione oficina</option>
          <ng-container *ngFor="let office of offices">
            <option [value]="office.id">
              {{ office.name }}
            </option>
          </ng-container>
        </select>
      </div>
      <div class="search">
        <div class="search-box flex align-middle pl-10 bg-[#F3F3F3] border-2 border-[#27368A] rounded-2xl w-80 h-12">
          <input #filter [(ngModel)]="searcherCriteria" (input)="onSearchInput($event)"
            class="col-span-4 bg-[#F3F3F3] font-bold border-0 outline-none" placeholder="BUSCAR RESERVA/TITULAR" />
        </div>
      </div>
    </div>

    <!--
      campos: importe, oficina, fecha y hora, serial
    -->

    <p-table [value]="filteredTickets" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="true" [rows]="7"
      [lazy]="true" [totalRecords]="totalRecords" (onLazyLoad)="loadTickets($event)" [loading]="loading">
      <ng-template pTemplate="header">
        <tr>
          <th scope="col" class="px-6 py-3">Serial del ticket</th>
          <th scope="col" class="px-6 py-3">Importe total</th>
          <th scope="col" class="px-6 py-3">Oficina</th>
          <th scope="col" class="px-6 py-3">Cod. empleado</th>
          <th scope="col" class="px-6 py-3">Fecha y hora</th>
          <th scope="col" class="px-6 py-3">Acciones</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-ticket let-i="rowIndex">
        <tr appButtonsHoverTable>
          <td scope="row" class="px-6 py-4 font-medium whitespace-nowrap">
            {{ ticket.serial }}
          </td>
          <td class="px-6 py-4 text-right font-bold">
            {{ ticket.total?.toFixed(2) }}€
          </td>
          <td class="px-6 py-4">{{ ticket.office?.name }}</td>
          <td class="px-6 py-4">{{ ticket.user?.employee_code }}</td>
          <td class="px-6 py-4">
            {{ formatDateToMadrid(ticket.issue_date) }}
          </td>
          <td class="px-6 py-4">
            <div class="flex gap-1 flex-wrap hide-buttons max-w-[140px]">
              <ng-container *ngIf="utils.validatePermission('see_invoices')">
                <button
                  class="bg-red-500 text-white px-1 rounded h-7 flex justify-center align-middle items-center text-nowrap"
                  [routerLink]="[
                  '/panel/payments/invoices/edit',
                  ticket.invoice_id
                ]" *ngIf="
                  ticket.status == 1 &&
                  ticket.invoice_generation != null &&
                  ticket.same_quarter == true &&
                  ticket.invoice_id != null
                ">
                  Editar factura
                </button>
                <button
                  class="bg-red-500 text-white px-1 rounded h-7 flex justify-center align-middle items-center text-nowrap"
                  (click)="cancelTicketInvoice($event, ticket.id, i)" *ngIf="
                  ticket.status == 1 &&
                  ticket.invoice_generation != null &&
                  ticket.same_quarter == false
                ">
                  Anular factura y crear nueva
                </button>
                <!-- *ngIf="ticket.status == 1" -->
                <!-- [routerLink]="'http://localhost:8000/invoices/ticket/generate/'+ticket.id+'?token='+tokenService?.getToken()" -->
                <button class="bg-red-500 text-white px-1 rounded h-7 flex justify-center align-middle items-center"
                  (click)="showAttachClientModal(ticket)" *ngIf="!ticket.customer_id || !ticket.customer?.address">
                  Adjuntar cliente
                </button>
              </ng-container>
              <button *ngIf="ticket.status != 2"
                class="bg-[#e7183b] rounded h-7 w-8 flex justify-center align-middle items-center"
                (click)="ticketReturn($event, ticket)" pTooltip="Marcar como devolución" tooltipPosition="bottom"
                [disabled]="!utils.validatePermission('return_ticket')">
                <img class="h-5" src="/assets/icons/icon_go_back.png" alt="icon-go-back" />
              </button>

              <button *ngIf="ticket.status == 2"
                class="bg-[#189CE7] rounded h-7 w-8 flex justify-center align-middle items-center"
                (click)="ticketReturnSee($event, ticket.id)" pTooltip="Ver devolución" tooltipPosition="bottom"
                [disabled]="!utils.validatePermission('return_ticket')">
                <img class="h-5" src="/assets/icons/icon_eye.png" alt="icon-go-back" />
              </button>

              <button class="bg-[#189CE7] rounded h-7 w-8 flex justify-center align-middle items-center"
                (click)="seeTicket($event, ticket.id)" pTooltip="Ver ticket" tooltipPosition="left">
                <img class="h-5" src="/assets/icons/icon_eye.png" alt="icon-eye" />
              </button>
              <ng-container *ngIf="isConnected">
                <button class="bg-[#189CE7] rounded h-7 w-8 flex justify-center align-middle items-center"
                  (click)="printTicket($event, ticket.id)" pTooltip="Imprimir" tooltipPosition="left">
                  <img class="h-5" src="/assets/icons/icon_print.png" alt="icon-print" />
                </button>
              </ng-container>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td class="text-center" colspan="6">No exiten tickets aun</td>
        </tr>
      </ng-template>
    </p-table>
  </section>

  <!-- return ticket -->
  <p-dialog header="Marcar ticket con estado de devolución" [(visible)]="showRefundTicket" [modal]="true"
    [style]="{ width: '90%', maxWidth: '500px' }">
    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-2">
        <label for="comment-refund" class="block">Comentario de justificación</label>

        <textarea id="comment-refund" [(ngModel)]="commentRefund" class="bg-[#F3F3F3] block py-1 px-2 w-full" cols="30"
          rows="7"></textarea>
      </div>
      <!-- <div class="flex flex-row gap-2 align-middle justify-between mb-[100px]">
        <label for="total_amount" class="w-[160px]">Importe</label>
        <input id="total_amount" type="text" [(ngModel)]="cashAmountBooking" (keydown)="utils.onlyNumbers($event)"
          class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-full">
      </div> -->
    </div>
    <div class="flex justify-end">
      <button
        class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
        (click)="sendTicketRefund($event)" [disabled]="commentRefund.trim() == ''">
        Aceptar
      </button>
    </div>
  </p-dialog>

  <!----------return booking ticket modal-------------->
  <p-dialog [modal]="true" [(visible)]="showRefundBookingTicket"
    [style]="{width: '90%', minWidth: '320px', maxWidth: '450px'}" [header]="headerRefund">
    <form [formGroup]="formRefund" (ngSubmit)="sendBookingTicketRefund()">
      <div>
        <label for="" class="text-[#27368A] font-bold text-base">Cambiar estado de reserva</label>
        <div class="flex gap-2">
          <input type="radio" formControlName="status_id" value="6">
          <span>Cancelar reserva</span>
        </div>
        <div class="flex gap-2">
          <input type="radio" formControlName="status_id" value="2">
          <span>Pendiente de pago</span>
        </div>
        <div class="flex gap-2">
          <input type="radio" formControlName="status_id" value="3">
          <span>Reservado</span>
        </div>
      </div>
      <div>
        <div class="mt-3">
          <label for="payment_method" class="text-[#27368A] font-bold text-base">Método de pago <span
              class="text-red-600">*</span></label>
          <select formControlName="payment_method" id="payment_method"
            class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <option value="EFECTIVO">Efectivo</option>
            <option value="TARJETA">Tarjeta</option>
            <option value="BIZUM">Bizum</option>
            <option value="TRANSFERENCIA">Transferencia</option>
          </select>
        </div>
      </div>
      <div class="mt-3">
        <label for="" class="text-[#27368A] font-bold text-base">Importe a devolver <span
            class="text-red-600">*</span></label>
        <input type="text" formControlName="unit_price" [readonly]="isRefundAmountLocked"
          class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
        <label for="" class="text-red-600 block" [ngClass]="{'hidden': isRefundAmountLocked}">Monto máximo a
          devolver: {{ getMaxRefundAmount() | currency: 'EUR' }}</label>
        <div *ngIf="formRefund.get('amount')?.touched && formRefund.get('amount')?.hasError('pattern')"
          class="text-red-600 text-xs">
          Por favor ingresa un número válido.
        </div>
      </div>
      <div class="mt-3">
        <label for="" class="text-[#27368A] font-bold text-base">Justificación <span
            class="text-red-600">*</span></label>
        <textarea formControlName="refund_comment"
          class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full"></textarea>
      </div>
      <div class="flex justify-end">
          <button [disabled]="formRefund.invalid || formRefund.value.amount > getMaxRefundAmount()" type="submit"
            class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-8 w-40 px-4 hover:bg-[#27368A] disabled:opacity-65 disabled:hover:bg-black">
            Guardar
          </button>
      </div>
    </form>
  </p-dialog>

  <!-- cancel ticket -->
  <p-dialog header="Marcar ticket con estado cancelado" [(visible)]="showCancelTicket" [modal]="true"
    [style]="{ width: '90%', maxWidth: '500px' }">
    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-2">
        <label for="comment-refund" class="block">Comentario de justificación</label>

        <textarea id="comment-cancel" [(ngModel)]="commentCancel" class="bg-[#F3F3F3] block py-1 px-2 w-full" cols="30"
          rows="7"></textarea>
      </div>
      <!-- <div class="flex flex-row gap-2 align-middle justify-between mb-[100px]">
        <label for="total_amount" class="w-[160px]">Importe</label>
        <input id="total_amount" type="text" [(ngModel)]="cashAmountBooking" (keydown)="utils.onlyNumbers($event)"
          class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-full">
      </div> -->
    </div>
    <div class="flex justify-end">
      <button
        class="bg-[#42BC18] justify-center items-center text-white text-lg font-bold mt-6 p-2 w-20 disabled:cursor-not-allowed disabled:opacity-40"
        (click)="sendTicketCancel($event)" [disabled]="commentCancel.trim() == ''">
        Aceptar
      </button>
    </div>
  </p-dialog>

  <!-- see return ticket -->
  <p-dialog header="Información de devolución de ticket" [(visible)]="showRefundTicketSee" [modal]="true"
    [style]="{ width: '90%', maxWidth: '500px' }">
    <div class="flex flex-col gap-3">
      <div class="flex flex-col gap-2">
        <label for="comment-refund" class="block">Responsable</label>
        <input type="text" [(ngModel)]="responsibleRefundSee" readonly class="bg-[#F3F3F3] block py-1 px-2 w-full"
          value="" />
      </div>
      <div class="flex flex-col gap-2">
        <label for="comment-refund" class="block">Comentario de justificación</label>

        <textarea id="comment-refund" [(ngModel)]="commentRefundSee" readonly
          class="bg-[#F3F3F3] block py-1 px-2 w-full" cols="30" rows="7"></textarea>
      </div>
      <!-- <div class="flex flex-row gap-2 align-middle justify-between mb-[100px]">
        <label for="total_amount" class="w-[160px]">Importe</label>
        <input id="total_amount" type="text" [(ngModel)]="cashAmountBooking" (keydown)="utils.onlyNumbers($event)"
          class="bg-[#F3F3F3] flex justify-end py-1 px-2 w-full">
      </div> -->
    </div>
    <div class="flex justify-end"></div>
  </p-dialog>


  <!---------------------------------------------MODAL CLIENTE------------------------------------------------>

    <p-dialog [modal]="true" [(visible)]="formSteps['customerDataForm']" [style]="{width: '35vw'}"
      header="Titular de ticket" (onHide)="resetCustomer()">
      <form [formGroup]="formCustomer" (ngSubmit)="saveCustomer()">
        <ng-template pTemplate="header">
          <h4 class="text-[#27368A] font-extrabold text-xl flex place-items-center">
            Seleccione titular del ticket
          </h4>
        </ng-template>
        <div class="flex flex-col  justify-center">
          <p-autoComplete [tabindex]="1" #searcherAutocomplete [suggestions]="results" [showClear]="true"
            [virtualScrollItemSize]="50" (completeMethod)="searchCustomer($event)" (onSelect)="onSelectCustomer($event)"
            styleClass="w-full" field="name" value="name"
            inputStyleClass="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 w-full px-2 mb-2 "
            placeholder="Buscar cliente">
            <ng-template let-item pTemplate="itemTemplate">
              <div class="autocomplete-item">
                <h3>{{item.name}}</h3>
                <span class="text-xs text-gray-700">{{item.email}}</span>
              </div>
            </ng-template>
          </p-autoComplete>
          <div class="mb-2">
            <label for="name" class="text-[#27368A] font-bold text-base">
              Nombre completo:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('name')?.touched && formCustomer.get('name')?.hasError('required')}"
              formControlName="name" type="text" placeholder="Nuevo Cliente" tabindex="2"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
            <div *ngIf="formCustomer.controls['name'].touched">
              <p *ngIf="formCustomer.get('name')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="cif" class="text-[#27368A] font-bold text-base">
              Documento Identificación:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('cif')?.touched && formCustomer.get('cif')?.hasError('required')}"
              formControlName="cif" type="text" placeholder="DNI/CIF/NIE"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full" tabindex="3">
            <div *ngIf="formCustomer.controls['cif'].touched">
              <p *ngIf="formCustomer.get('cif')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="phone" class="text-[#27368A] font-bold text-base">
              Teléfono:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('phone')?.touched && formCustomer.get('phone')?.hasError('required')}"
              formControlName="phone" type="text" placeholder="teléfono"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full" tabindex="4">
            <div *ngIf="formCustomer.controls['phone'].touched">
              <p *ngIf="formCustomer.get('phone')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
            </div>
          </div>
          <div class="mb-2">
            <label for="email" class="text-[#27368A] font-bold text-base">
              Email:
            </label>
            <input
              [ngClass]="{'border-red-600' : formCustomer.get('email')?.touched && formCustomer.get('email')?.hasError('required')}"
              formControlName="email" type="email" placeholder="email"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full" tabindex="5">
            <div *ngIf="formCustomer.controls['email'].touched">
              <p *ngIf="formCustomer.get('email')?.hasError('required')" class="text-red-600 text-xs font-bold">
                Campo obligatorio
              </p>
              <p *ngIf="formCustomer.get('email')?.hasError('email')" class="text-red-600 text-xs font-bold">
                Formato no
                válido
              </p>
            </div>
          </div>
          <div *ngIf="selectedCustomer || !address" class="mb-4">
            <div class="flex flex-row gap-3">
              <p class="text-[#27368A] font-extrabold text-lg">Dirección</p>
              <button type="button" (click)="toggleForm('addressCustomerForm')" *ngIf="!address"
                class="text-white font-bold text-base flex justify-center align-middle items-center bg-black rounded-lg h-6 w-6 p-1 hover:bg-[#27368A]">
                +
              </button>
            </div>
            <ng-container *ngIf="address">
              <div class="grid grid-cols-8">
                <div class="col-span-7 flex flex-wrap">
                  <p class="text-[#8A8A8A] font-bold text-base mr-1">
                    {{address?.alias }}:
                  </p>
                  <p class="text-[#8A8A8A] text-base text-clip">
                    {{ address?.street_name }}
                    {{ address?.street_number }}
                    {{ address?.floor }}
                    {{ address?.description }}
                    {{ address?.city }}-
                    {{ address?.province }}
                    {{ address?.country }}
                    {{ address?.postal_code }}
                  </p>
                </div>
                <div class="col-span-1 flex flex-row  gap-2">
                  <button type="button" (click)="editAddress(address)" pInputText>
                    <i class="pi pi-pencil" style="font-size: 0.2rem" style="color: #27368A"></i>
                  </button>
                  <button type="button" (click)="deleteAddress(address)" pInputText>
                    <i class="pi pi-times" style="font-size: 0.2rem" style="color: red"></i>
                  </button>
                </div>
              </div>
            </ng-container>
          </div>
          <div class="flex flex-row justify-end">
            <button type="submit" [disabled]="validateSimpleTicket()"
              class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-8 w-40 px-6 hover:bg-[#27368A] disabled:opacity-75 disabled:hover:bg-black">
              Aceptar
            </button>
          </div>
        </div>
      </form>
    </p-dialog>


  <!---------------------------------------------MODAL DIRECCIÓN------------------------------------------------>
  <ng-container *ngIf="formAddressCustomer">
    <p-dialog [modal]="true" [(visible)]="formSteps['addressCustomerForm']" [style]="{width: '50%'}"
      [breakpoints]="{ '1900px': '75%' }" header="Dirección del titular">
      <form [formGroup]="formAddressCustomer">
        <ng-template pTemplate="header">
          <h4 class="text-[#27368A] font-extrabold text-xl flex place-items-center">Dirección</h4>
        </ng-template>
        <div class="grid grid-cols-2 gap-10 justify-center">
          <div class=" flex flex-col">
            <div class="mb-2">
              <label for="street_name" class="text-[#27368A] font-bold text-base">
                Nombre de la calle:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('street_name')?.touched && formAddressCustomer.get('street_name')?.hasError('required')}"
                tabindex="1" formControlName="street_name" type="text" placeholder="Nombre de la calle"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['street_name'].touched">
                <p *ngIf="formAddressCustomer.get('street_name')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <div class="mb-2">
              <label for="street_number" class="text-[#27368A] font-bold text-base">
                Número:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('street_number')?.touched && formAddressCustomer.get('street_number')?.hasError('required')}"
                tabindex="2" formControlName="street_number" type="text" placeholder="Numero de la calle"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['street_number'].touched">
                <p *ngIf="formAddressCustomer.get('street_number')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <label for="floor" class="text-[#27368A] font-bold text-base">
              Piso:
            </label>
            <input formControlName="floor" type="text" placeholder="piso" tabindex="3"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full mb-2 ">
            <label for="description" class="text-[#27368A] font-bold text-base">
              Letra/Descripción:
            </label>
            <input formControlName="description" tabindex="4" type="text" placeholder="Letra/Descripción"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
          </div>
          <div class="flex flex-col">
            <div class="mb-2">
              <label for="city" class="text-[#27368A] font-bold text-base">
                Ciudad:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('city')?.touched && formAddressCustomer.get('city')?.hasError('required')}"
                tabindex="5" formControlName="city" type="text" placeholder="Ciudad"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['city'].touched">
                <p *ngIf="formAddressCustomer.get('city')?.hasError('required')" class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <label for="province" class="text-[#27368A] font-bold text-base">
              Provincia:
            </label>
            <input formControlName="province" tabindex="6" type="text" placeholder="Provincia"
              class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full mb-2 ">
            <div class="mb-2">
              <label for="country" class="text-[#27368A] font-bold text-base">
                País:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('country')?.touched && formAddressCustomer.get('country')?.hasError('required')}"
                tabindex="7" formControlName="country" type="text" placeholder="País"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['country'].touched">
                <p *ngIf="formAddressCustomer.get('country')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
              </div>
            </div>
            <div class="mb-2">
              <label for="postal_code" class="text-[#27368A] font-bold text-base">
                Código postal:
              </label>
              <input
                [ngClass]="{'border-red-600' : formAddressCustomer.get('postal_code')?.touched && formAddressCustomer.get('postal_code')?.hasError('required')}"
                tabindex="8" formControlName="postal_code" type="text" placeholder="Código postal"
                class="bg-[#F3F3F3] border-2 border-[#27368A] rounded-lg py-1 px-2 w-full">
              <div *ngIf="formAddressCustomer.controls['postal_code'].touched">
                <p *ngIf="formAddressCustomer.get('postal_code')?.hasError('required')"
                  class="text-red-600 text-xs font-bold">
                  Campo obligatorio
                </p>
                <p *ngIf="formAddressCustomer.get('postal_code')?.hasError('pattern')"
                  class="text-red-600 text-xs font-bold">
                  Mínimo de 5 caracteres (letras y/o números)
                </p>
              </div>
            </div>
            <div class="flex justify-end  mt-4">
              <div *ngIf="warningMessage" class="text-red-600 text-xs font-bold flex align-middle items-center">
                {{ warningMessage }}
              </div>
              <button type="button" [ngClass]="{'bg-gray-500 hover:bg-gray-500': !formAddressCustomer.valid}"
                [disabled]="!formAddressCustomer.valid" (click)="saveAddressCustomer()"
                class="text-white font-bold text-base flex place-content-center justify-center align-middle items-center bg-black rounded-lg mt-2 h-9 w-32 px-6 ml-4 hover:bg-[#27368A]">
                Guardar
              </button>
            </div>
          </div>
        </div>
      </form>
    </p-dialog>
  </ng-container>

</main>
<p-toast></p-toast>
